import { Button } from '@avanta/shared/components/ui/Button';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { PatientCard, type PatientCardPatient } from '../PatientCard';

interface SelectedPatientViewProps {
  patient: PatientCardPatient;
  onBack: () => void;
  onNext?: () => void;
}

export const SelectedPatientView = ({
  patient,
  onBack,
  onNext,
}: SelectedPatientViewProps): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.APPOINTMENTS);

  return (
    <div className="flex w-full flex-col gap-10">
      <PatientCard patient={patient} isSelected />
      <div className="flex w-full justify-between">
        <Button
          type="button"
          size="lg"
          icon="back"
          variant="terciary"
          className="w-fit"
          onClick={onBack}
        >
          <ChevronLeft className="size-6" />
          {t('Common.back', { ns: LOCIZE_NS.COMMON })}
        </Button>
        {onNext && (
          <Button
            type="button"
            size="lg"
            icon="trailing"
            className="min-w-37 w-fit"
            onClick={onNext}
          >
            {t('AppointmentsReserve.next')}
            <ChevronRight className="size-6" />
          </Button>
        )}
      </div>
    </div>
  );
};
